var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.6,
    height: 20.6,
    viewBox: "0 0 19.6 20.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_1_",
    "data-name": "pin (1)",
    transform: "translate(1.3 0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M25.5,17A2.5,2.5,0,1,0,23,14.5,2.5,2.5,0,0,0,25.5,17Zm0-4.286A1.786,1.786,0,1,1,23.714,14.5,1.788,1.788,0,0,1,25.5,12.714Z",
    transform: "translate(-17 -9)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M16.147,16l4.4-6.474a6.478,6.478,0,0,0-.511-7.884,5.429,5.429,0,0,0-7.779,0,6.476,6.476,0,0,0-.517,7.875ZM12.663,2.054a4.863,4.863,0,0,1,6.968,0,5.852,5.852,0,0,1,.451,7.129l-3.935,5.789-3.941-5.8A5.85,5.85,0,0,1,12.663,2.054Z",
    transform: "translate(-7.646 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M13.337,43a.327.327,0,0,0-.351.316.353.353,0,0,0,.277.4c3.33.446,5.1,1.649,5.1,2.346,0,.979-3.373,2.344-8.867,2.344S.633,47.043.633,46.065c0-.7,1.774-1.9,5.1-2.346a.354.354,0,0,0,.277-.4A.327.327,0,0,0,5.663,43C2.329,43.449,0,44.708,0,46.065c0,1.523,3.263,3.065,9.5,3.065S19,47.588,19,46.065C19,44.708,16.671,43.449,13.337,43Z",
    transform: "translate(-1 -29.13)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.42d71783de665947634c845039d1a891.svg";
export { ForwardRef as ReactComponent };